import { GenIcon } from 'react-icons';
export const MdCurrencyFlagUsd = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_21686_23862)' },
            child: [
                {
                    tag: 'rect',
                    attr: {
                        width: '24',
                        height: '24.0005',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M23.0965 7.4371H13V9.27418H23.6866C23.5395 8.6446 23.3408 8.03083 23.0965 7.4371ZM20.7241 3.76174H13V5.60064H22.1479C21.7347 4.94493 21.2576 4.32873 20.7241 3.76174ZM3.3352 20.299H20.667C21.2036 19.74 21.6885 19.1256 22.1121 18.462H1.89255C2.31186 19.1177 2.79497 19.7333 3.3352 20.299ZM14.8824 0.35377C14.5221 0.264438 13.3597 0.0553006 13 0V1.92467H18.5194C17.4317 1.22096 16.2108 0.682535 14.8824 0.35377ZM23.9673 11.1112H13.0006V12.9501H23.9606C24.0105 12.3315 24.0117 11.7171 23.9673 11.1112ZM0.92998 16.6255H23.0716C23.3037 16.0682 23.4964 15.4861 23.6459 14.882C23.6538 14.8504 23.6604 14.8188 23.6683 14.7866H0.328979C0.480293 15.4168 0.681437 16.0324 0.92998 16.6255ZM9.11793 23.645C9.8277 23.8207 10.5387 23.9288 11.2436 23.9744H12.7707C14.801 23.8444 16.7401 23.1984 18.4179 22.1361H5.57695C6.6404 22.8094 7.82842 23.3266 9.11793 23.645Z',
                        fill: '#EF3827',
                    },
                    child: [],
                },
                {
                    tag: 'rect',
                    attr: {
                        width: '13',
                        height: '13.0003',
                        fill: '#223C72',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M2.39949 12.1737L2.65898 12.3627L2.56053 12.0583L2.82001 11.8693H2.49855L2.39949 11.5648L2.29983 11.8693H1.97958L2.23967 12.0583L2.14062 12.3627L2.39949 12.1737Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M0.019886 12.1737L0.279367 12.3627L0.180923 12.0583L0.440404 11.8693H0.118939L0.019886 11.5648L-0.0797744 11.8693H-0.400024L-0.139935 12.0583L-0.238988 12.3627L0.019886 12.1737Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M4.81987 12.1607L5.07936 12.3497L4.98091 12.0453L5.24039 11.8563H4.91893L4.81987 11.5518L4.72021 11.8563H4.39996L4.66005 12.0453L4.561 12.3497L4.81987 12.1607Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M7.21987 12.1477L7.47935 12.3367L7.3809 12.0323L7.64039 11.8433H7.31892L7.21987 11.5388L7.12021 11.8433H6.79996L7.06005 12.0323L6.96099 12.3367L7.21987 12.1477Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M9.61986 12.1477L9.87934 12.3367L9.7809 12.0323L10.0404 11.8433H9.71891L9.61986 11.5388L9.5202 11.8433H9.19995L9.46004 12.0323L9.36099 12.3367L9.61986 12.1477Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12.0199 12.1477L12.2794 12.3367L12.1809 12.0323L12.4404 11.8433H12.1189L12.0199 11.5388L11.9202 11.8433H11.6L11.8601 12.0323L11.761 12.3367L12.0199 12.1477Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M1.14949 10.8867L1.40898 11.0757L1.31053 10.7713L1.57001 10.5823H1.24855L1.14949 10.2778L1.04983 10.5823H0.729584L0.989673 10.7713L0.89062 11.0757L1.14949 10.8867Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M3.56987 10.8737L3.82936 11.0627L3.73091 10.7583L3.99039 10.5693H3.66893L3.56987 10.2648L3.47021 10.5693H3.14996L3.41005 10.7583L3.311 11.0627L3.56987 10.8737Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M5.96987 10.8607L6.22935 11.0497L6.1309 10.7452L6.39039 10.5563H6.06892L5.96987 10.2518L5.87021 10.5563H5.54996L5.81005 10.7452L5.71099 11.0497L5.96987 10.8607Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M8.36986 10.8607L8.62934 11.0497L8.5309 10.7452L8.79038 10.5563H8.46891L8.36986 10.2518L8.2702 10.5563H7.94995L8.21004 10.7452L8.11099 11.0497L8.36986 10.8607Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M10.7699 10.8607L11.0294 11.0497L10.9309 10.7452L11.1904 10.5563H10.8689L10.7699 10.2518L10.6702 10.5563H10.35L10.6101 10.7452L10.511 11.0497L10.7699 10.8607Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M1.14949 8.28665L1.40898 8.47564L1.31053 8.17119L1.57001 7.98219H1.24855L1.14949 7.67773L1.04983 7.98219H0.729584L0.989673 8.17119L0.89062 8.47564L1.14949 8.28665Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M3.56987 8.27365L3.82936 8.46264L3.73091 8.15819L3.99039 7.96919H3.66893L3.56987 7.66473L3.47021 7.96919H3.14996L3.41005 8.15819L3.311 8.46264L3.56987 8.27365Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M5.96987 8.26065L6.22935 8.44964L6.1309 8.14518L6.39039 7.95619H6.06892L5.96987 7.65173L5.87021 7.95619H5.54996L5.81005 8.14518L5.71099 8.44964L5.96987 8.26065Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M8.36986 8.26065L8.62934 8.44964L8.5309 8.14518L8.79038 7.95619H8.46891L8.36986 7.65173L8.2702 7.95619H7.94995L8.21004 8.14518L8.11099 8.44964L8.36986 8.26065Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M10.7699 8.26065L11.0294 8.44964L10.9309 8.14518L11.1904 7.95619H10.8689L10.7699 7.65173L10.6702 7.95619H10.35L10.6101 8.14518L10.511 8.44964L10.7699 8.26065Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M1.14949 5.58658L1.40898 5.77557L1.31053 5.47111L1.57001 5.28212H1.24855L1.14949 4.97766L1.04983 5.28212H0.729584L0.989673 5.47111L0.89062 5.77557L1.14949 5.58658Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M3.56987 5.57358L3.82936 5.76257L3.73091 5.45811L3.99039 5.26912H3.66893L3.56987 4.96466L3.47021 5.26912H3.14996L3.41005 5.45811L3.311 5.76257L3.56987 5.57358Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M5.96987 5.56057L6.22935 5.74957L6.1309 5.44511L6.39039 5.25612H6.06892L5.96987 4.95166L5.87021 5.25612H5.54996L5.81005 5.44511L5.71099 5.74957L5.96987 5.56057Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M8.36986 5.56057L8.62934 5.74957L8.5309 5.44511L8.79038 5.25612H8.46891L8.36986 4.95166L8.2702 5.25612H7.94995L8.21004 5.44511L8.11099 5.74957L8.36986 5.56057Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M10.7699 5.56057L11.0294 5.74957L10.9309 5.44511L11.1904 5.25612H10.8689L10.7699 4.95166L10.6702 5.25612H10.35L10.6101 5.44511L10.511 5.74957L10.7699 5.56057Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M3.56987 2.82351L3.82936 3.01251L3.73091 2.70805L3.99039 2.51906H3.66893L3.56987 2.2146L3.47021 2.51906H3.14996L3.41005 2.70805L3.311 3.01251L3.56987 2.82351Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M5.96987 2.81051L6.22935 2.99951L6.1309 2.69505L6.39039 2.50606H6.06892L5.96987 2.2016L5.87021 2.50606H5.54996L5.81005 2.69505L5.71099 2.99951L5.96987 2.81051Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M8.36986 2.81051L8.62934 2.99951L8.5309 2.69505L8.79038 2.50606H8.46891L8.36986 2.2016L8.2702 2.50606H7.94995L8.21004 2.69505L8.11099 2.99951L8.36986 2.81051Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M10.7699 2.81051L11.0294 2.99951L10.9309 2.69505L11.1904 2.50606H10.8689L10.7699 2.2016L10.6702 2.50606H10.35L10.6101 2.69505L10.511 2.99951L10.7699 2.81051Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M2.39949 9.58667L2.65898 9.77566L2.56053 9.4712L2.82001 9.28221H2.49855L2.39949 8.97775L2.29983 9.28221H1.97958L2.23967 9.4712L2.14062 9.77566L2.39949 9.58667Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M0.019886 9.58667L0.279367 9.77566L0.180923 9.4712L0.440404 9.28221H0.118939L0.019886 8.97775L-0.0797744 9.28221H-0.400024L-0.139935 9.4712L-0.238988 9.77566L0.019886 9.58667Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M4.81987 9.57366L5.07936 9.76266L4.98091 9.4582L5.24039 9.26921H4.91893L4.81987 8.96475L4.72021 9.26921H4.39996L4.66005 9.4582L4.561 9.76266L4.81987 9.57366Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M7.21987 9.56066L7.47935 9.74966L7.3809 9.4452L7.64039 9.25621H7.31892L7.21987 8.95175L7.12021 9.25621H6.79996L7.06005 9.4452L6.96099 9.74966L7.21987 9.56066Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M9.61986 9.56066L9.87934 9.74966L9.7809 9.4452L10.0404 9.25621H9.71891L9.61986 8.95175L9.5202 9.25621H9.19995L9.46004 9.4452L9.36099 9.74966L9.61986 9.56066Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12.0199 9.56066L12.2794 9.74966L12.1809 9.4452L12.4404 9.25621H12.1189L12.0199 8.95175L11.9202 9.25621H11.6L11.8601 9.4452L11.761 9.74966L12.0199 9.56066Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M2.39949 6.88662L2.65898 7.07562L2.56053 6.77116L2.82001 6.58217H2.49855L2.39949 6.27771L2.29983 6.58217H1.97958L2.23967 6.77116L2.14062 7.07562L2.39949 6.88662Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M4.81987 6.87362L5.07936 7.06262L4.98091 6.75816L5.24039 6.56917H4.91893L4.81987 6.26471L4.72021 6.56917H4.39996L4.66005 6.75816L4.561 7.06262L4.81987 6.87362Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M7.21987 6.86062L7.47935 7.04962L7.3809 6.74516L7.64039 6.55616H7.31892L7.21987 6.25171L7.12021 6.55616H6.79996L7.06005 6.74516L6.96099 7.04962L7.21987 6.86062Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M9.61986 6.86062L9.87934 7.04962L9.7809 6.74516L10.0404 6.55616H9.71891L9.61986 6.25171L9.5202 6.55616H9.19995L9.46004 6.74516L9.36099 7.04962L9.61986 6.86062Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12.0199 6.86062L12.2794 7.04962L12.1809 6.74516L12.4404 6.55616H12.1189L12.0199 6.25171L11.9202 6.55616H11.6L11.8601 6.74516L11.761 7.04962L12.0199 6.86062Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M2.39949 4.18655L2.65898 4.37554L2.56053 4.07109L2.82001 3.88209H2.49855L2.39949 3.57764L2.29983 3.88209H1.97958L2.23967 4.07109L2.14062 4.37554L2.39949 4.18655Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M4.81987 4.17355L5.07936 4.36254L4.98091 4.05809L5.24039 3.86909H4.91893L4.81987 3.56464L4.72021 3.86909H4.39996L4.66005 4.05809L4.561 4.36254L4.81987 4.17355Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M7.21987 4.16055L7.47935 4.34954L7.3809 4.04509L7.64039 3.85609H7.31892L7.21987 3.55164L7.12021 3.85609H6.79996L7.06005 4.04509L6.96099 4.34954L7.21987 4.16055Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M9.61986 4.16055L9.87934 4.34954L9.7809 4.04509L10.0404 3.85609H9.71891L9.61986 3.55164L9.5202 3.85609H9.19995L9.46004 4.04509L9.36099 4.34954L9.61986 4.16055Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12.0199 4.16055L12.2794 4.34954L12.1809 4.04509L12.4404 3.85609H12.1189L12.0199 3.55164L11.9202 3.85609H11.6L11.8601 4.04509L11.761 4.34954L12.0199 4.16055Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M7.21987 1.46048L7.47935 1.64947L7.3809 1.34501L7.64039 1.15602H7.31892L7.21987 0.851562L7.12021 1.15602H6.79996L7.06005 1.34501L6.96099 1.64947L7.21987 1.46048Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M9.61986 1.46048L9.87934 1.64947L9.7809 1.34501L10.0404 1.15602H9.71891L9.61986 0.851562L9.5202 1.15602H9.19995L9.46004 1.34501L9.36099 1.64947L9.61986 1.46048Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12.0199 1.46048L12.2794 1.64947L12.1809 1.34501L12.4404 1.15602H12.1189L12.0199 0.851562L11.9202 1.15602H11.6L11.8601 1.34501L11.761 1.64947L12.0199 1.46048Z',
                        fill: 'white',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12 0.5C18.3512 0.5 23.4999 5.64869 23.5 12C23.5 18.3514 18.3513 23.501 12 23.501C5.64874 23.501 0.5 18.3514 0.5 12C0.500145 5.64869 5.64883 0.5 12 0.5Z',
                        stroke: 'white',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_21686_23862' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '24',
                                height: '24',
                                rx: '12',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
